export default "__VITE_ASSET__CZ5FDjyl__";